import React from 'react';
import ListItemText, { ListItemTextProps } from '@material-ui/core/ListItemText';
import { UdsFC } from '../../types';

export const MenuListItemText: UdsFC<ListItemTextProps> = ({ dataTest, ...props }) => (
  <ListItemText data-test={dataTest} {...props} />
);
